module.exports = __webpack_public_path__ + "39f3cfcd96d57d456f9f4d4245d5a7c1.svg";